import { TickCircle } from 'iconsax-react';
import { Info, XCircle } from 'react-feather';
import { toast } from 'react-toastify';

import { ToastMsg } from './ToastMsg';

class Toast {
  private config = (type: string) => {
    return {
      icon:
        type === 'error' ? (
          <XCircle width={24} height={24} strokeWidth={'2'} className='text-red-1' />
        ) : type === 'success' ? (
          <TickCircle strokeWidth={'2'} className='text-green-1' />
        ) : (
          <Info strokeWidth={'2'} className='text-orange' />
        ),
      progressStyle: {
        backgroundColor: type === 'error' ? '#f7525f' : type === 'success' ? '#089981' : '#fff',
        height: '2px',
      },
      delay: 300,
      closeButton: false,
    };
  };
  info = (message: string, title?: string) => {
    toast.error(<ToastMsg title={title} message={message} />, this.config('info'));
  };
  error = (message: string, title?: string) => {
    toast.error(<ToastMsg title={title} message={message} />, this.config('error'));
  };
  success = (message: string, title?: string) => {
    toast.success(<ToastMsg title={title} message={message} />, this.config('success'));
  };
}

export const ToastService = new Toast();
